/**
 * c端 勘察报告
 */
import {getMapping} from "@/js/member/project/mapping";

export const memberProjectMapping = {
    namespaced: true,
    state: {
        user_sign: {}, // 签单手信息
        tags: [], // 基本信息
        rooms: [], // 勘察信息
        areas: [], // 勘察设备
        position_kv: [], // 主机设备定位
        plans: [], // 设计方案
        attach: [], // 勘察图片
    },
    mutations: {
        /**
         * 签单手信息
         */
        changeUserInfo(state, payload) {
            state.user_sign = payload;
        },
        /**
         * 基本信息
         */ 
        changeTags(state, payload) {
            state.tags = payload;
        },
        /**
         * 勘察信息
         */
        changeRooms(state, payload) {
            state.rooms = payload;
        },
        /**
         * 勘察 设备
         */
        changeAreas(state, payload) {
            state.areas = payload;
        },
        /**
         * 主机设备定位
         */
        changePosition(state, payload) {
            state.position_kv = payload;
        },
        /**
         * 设计方案
         */
        changePlans(state, payload) {
            state.plans = payload;
        },
        /**
         * 勘察图片
         */
        changeAttach(state, payload) {
            state.attach = payload;
        },
    },
    actions: {
        async getData({commit, state}, payload) {
            await getMapping(payload).then((res) => {
                const infos = res.data.data.result.infos;

                commit("changeUserInfo", infos.user_sign);
                commit("changeTags", infos.tags);

                let floors = infos.floors;
                let rooms = [];
                let areas = []
                for (let i = 0; i < floors.length; i++) {
                    for (let j = 0; j < floors[i].rooms.length; j++) {
                        rooms.push(floors[i].rooms[j]);
                    }

                    for (let k = 0; k < floors[i].area.length; k++) {
                        areas.push(floors[i].area[k])
                    }
                }
                commit("changeRooms", rooms);

                let newList = [];
                function handler(arr, newList) {
                    let tempArr = [];
                    for (let i = 0; i < arr.length; i++) {
                        if (tempArr.indexOf(arr[i].type) === -1) {
                            newList.push({
                                type: arr[i].type,
                                name: arr[i].name,
                                num: [Number(arr[i].num)]
                            })
                            tempArr.push(arr[i].type)
                        } else {
                            for (let j = 0; j < newList.length; j++) {
                                if (newList[j].type === arr[i].type) {
                                    newList[j].num.push(Number(arr[i].num))
                                }
                            }
                        }
                    }
                    // console.log(newList, tempArr, '讲的啥');
                }
                handler(areas, newList)
                commit("changeAreas", newList);

                let position_kv = infos.position_kv;
                let position_kv_temp = [];
                for (let i = 0; i < position_kv.length; i++) {
                    for (let j = 0; j < position_kv[i].position.length; j++) {
                        position_kv_temp.push(position_kv[i].position[j]);
                    }
                }
                commit("changePosition", position_kv_temp);

                let arr = [];
                for (let i = 0; i < rooms.length; i++) {
                    if (i % 5 === 0) {
                        var a = [];
                        arr.push(a);
                    }
                    a.push(rooms[i]);
                }
                commit("changeAttach", arr);
                commit("changePlans", infos.attach);
            });
        },
    },
    getters: {},
};
